/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import React, { Fragment, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import ReplayButton from './ReplayButton';
import SkipButton from './SkipButton';

const Direction = observer(({ interactiveRef, handleExitWayfinding }) => {
    const { mapStore, mainStore } = useStores();

    const movementRef = useRef(null);

    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

    const [isMinimized, setIsMinimized] = useState(true);

    const handleStart = (e) => {
        const touch = e.touches[0];
        const rect = movementRef.current.getBoundingClientRect();
        setDragOffset({
            x: touch.clientX - rect.left,
            y: touch.clientY - rect.top,
        });
    };

    const handleMove = (e) => {
        e.stopPropagation();
        e.preventDefault();

        const touch = e.touches[0];
        const clientX = touch.clientX;
        const clientY = touch.clientY;

        const offsetX = 200;
        const offsetY = 80;

        const offsetCX = clientX - offsetX;
        const offsetCY = clientY - offsetY;

        movementRef.current.style.left = `${Math.round(offsetCX)}px`;
        movementRef.current.style.top = `${Math.round(offsetCY)}px`;
    };

    return (
        <div
            className="absolute bottom-[30px] right-1/2 translate-x-1/2 z-60 w-[80%] sm:w-[500px] h-fit"
            ref={movementRef}
        >
            <div className="relative flex flex-col justify-center gap-[6px]">
                {mapStore.isWayfindingSkipped ||
                mapStore.isWayfindingFinished ? (
                    <ReplayButton interactiveRef={interactiveRef} />
                ) : (
                    <SkipButton />
                )}

                {/* Directory Card */}
                {mapStore.isWayfindingFinished && (
                    <Fragment>
                        <div
                            className="mt-[6px] bg-[#F6F6F6]"
                            style={{
                                border: '1px solid #EEEEEE',
                                boxSizing: 'border-box',
                            }}
                        >
                            <div>
                                <div
                                    className="flex items-center p-1.5 text-center bg-[#1C1C1C] tracking-[.12em]"
                                    // onTouchStart={handleStart}
                                    onTouchMove={handleMove}
                                    onClick={() => setIsMinimized(!isMinimized)}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2 4.66602H14"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M2 8H14"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                        <path
                                            d="M2 11.334H14"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                        />
                                    </svg>

                                    <span className="flex-1 text-white text-xs sm:text-sm font-comfortaaBold">
                                        DIRECTION
                                    </span>

                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className={
                                            isMinimized ? 'rotate-180' : ''
                                        }
                                    >
                                        <path
                                            d="M14.6659 1.33398L9.19922 6.80065"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M8.66797 4.11328V7.33328H11.888"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                        <path
                                            d="M7.33203 1.33398H5.9987C2.66536 1.33398 1.33203 2.66732 1.33203 6.00065V10.0007C1.33203 13.334 2.66536 14.6673 5.9987 14.6673H9.9987C13.332 14.6673 14.6654 13.334 14.6654 10.0007V8.66732"
                                            stroke="white"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                </div>

                                <div
                                    className={`w-full transition-all duration-200 ease-in-out ${
                                        isMinimized
                                            ? 'p-0 h-0'
                                            : 'px-[6px] pb-[6px]'
                                    }p`}
                                >
                                    <div
                                        className={`${
                                            isMinimized
                                                ? 'm-0 max-h-[0px]'
                                                : 'mt-2 max-h-[146px] mb-2'
                                        } transition-all duration-200 ease-in-out space-y-1.5 scrollbar scrollable overflow-y-auto`}
                                    >
                                        {mapStore.directions.map(
                                            (direction, index) => {
                                                return (
                                                    <Fragment>
                                                        <div
                                                            onClick={() => {
                                                                mainStore.setFloorguideDirectionIndex(
                                                                    index
                                                                );
                                                                try {
                                                                    interactiveRef.current.cameraFocusOnDirection(
                                                                        mapStore,
                                                                        direction
                                                                    );
                                                                } catch (e) {}
                                                            }}
                                                            className={`flex items-center gap-2 text-[10px] sm:text-[12px] text-[#525252] font-regular cursor-pointer ${
                                                                mainStore.floorguideDirectionIndex !==
                                                                    index &&
                                                                'opacity-[0.40]'
                                                            }`}
                                                            key={index}
                                                        >
                                                            <span className="min-w-[60px]">
                                                                Step {index + 1}
                                                                :
                                                            </span>
                                                            <span>
                                                                {direction.instruction.replace(
                                                                    /<\/?[^>]+(>|$)/g,
                                                                    ''
                                                                )}
                                                            </span>
                                                        </div>
                                                    </Fragment>
                                                );
                                            }
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            onClick={handleExitWayfinding}
                            className="relative flex gap-1/2 items-center bg-[#EE3333] p-1.5 mx-auto w-full"
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="1.50841"
                                    height="21.1177"
                                    transform="matrix(0.707071 0.707143 -0.707071 0.707143 14.9336 0)"
                                    fill="white"
                                />
                                <rect
                                    width="1.50841"
                                    height="21.1177"
                                    transform="matrix(-0.707071 0.707143 0.707071 0.707143 1.06641 0)"
                                    fill="white"
                                />
                            </svg>

                            <div className="flex-1 pr-4 text-center font-semibold text-xs sm:text-sm text-white tracking-[.12em]">
                                EXIT NAVIGATION
                            </div>
                        </button>
                    </Fragment>
                )}
            </div>
        </div>
    );
});

export default Direction;
